import styled, { css } from 'styled-components'

//import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'

export const APListViewFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 2px;
  gap: ${theme.spacing.tiny};

  width: 100%;
  min-height: 500px;
  height: -webkit-fill-available;

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;

  @media ${theme.devices.mobile} {
    width: 100%;
    margin: 0px;
    padding: 0px;
    height: 500px;
  }
`

export const APListViewColumnHeaderFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 24px 0px 6px;
  gap: ${theme.spacing.tiny};
  height: 48px;
  background: #ffffff;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const APListViewColumnNameInnerFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 74px;
  height: 24px;
  flex: none;
  order: 0;
  flex-grow: 0;
`

export const APListViewColumnBase = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  white-space: nowrap;
  align-items: left;
  gap: ${theme.spacing.tiny};
  height: 29px;
  width: 100%;
`

export const APListViewColumnName = styled.div`
  ${APListViewColumnBase};
  min-width: 350px;

  @media ${theme.devices.tablet} {
    min-width: 175px;
  }

  @media ${theme.devices.mobile} {
    min-width: 150px;
  }

  @media ${theme.devices.mediumDesktop} {
    min-width: 350px;
  }
`

export const APListViewColumnMAC = styled.div`
  ${APListViewColumnBase};
  min-width: 125px;
`

export const APListViewColumnFirmware = styled.div`
  ${APListViewColumnBase};
  min-width: 130px;

  @media ${theme.devices.tablet} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListViewColumnIP = styled.div`
  ${APListViewColumnBase};
  min-width: 105px;
  @media ${theme.devices.tablet} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListViewColumnUptime = styled.div`
  ${APListViewColumnBase};
  min-width: 70px;
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListViewColumnClients = styled.div`
  ${APListViewColumnBase};
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListViewColumnBytes = styled.div`
  ${APListViewColumnBase};
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListViewColumnTrash = styled.div`
  ${APListViewColumnBase};
  max-width: 35px;
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListViewColumnText = styled.span`
  font-size: 14px;
  color: ${theme.colors.otterWarmBlack};
`

export const NetworkClientmobile = styled.div`
  display: none;
  @media ${theme.devices.mobile} {
    display: flex;
  }
`
export const NetworkClienttablet = styled.div`
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
  }
`
export const NetworkClienttabletMid = styled.div`
  display: none;
  @media ${theme.devices.tabletMid} {
    display: flex;
  }
`
export const NetworkClienttabletLandscape = styled.div`
  display: none;
  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }
`
export const NetworkClienttabletMidLandscape = styled.div`
  display: none;
  @media ${theme.devices.tabletMidLandscape} {
    display: flex;
  }
`
export const NetworkClientdesktop = styled.div`
  display: none;
  @media ${theme.devices.desktop} {
    display: flex;
  }
`
export const NetworkClientmediumDesktop = styled.div`
  display: none;
  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`
